import React from "react";

import { Button, Col, message, Modal, Radio, Row, Select } from "antd";
import {
    IotDeviceService
} from "../../services";

const { Option } = Select;

class BookLockerBoxModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            /* TMP UI STATE */
            step: 0,
            dataFetchAttempted: false,
            pendingConfirmationFromServer: false,
            selectedLockerName: "",
            selectedBoxSizes: this.props.selectedLocationsData.map(
                _location => {

                    return {
                        deliveryId: _location._id,
                        doNumber: "",
                        boxSize: ""
                    }

                }
            ),

            /* DATABASE DATA */
            iotLockers: [],
            iotLockerBoxes: []
        }
    }

    async componentDidMount() {



        let [iotDevicesResponse, iotLockerBoxesResponse] = await Promise.all([
            IotDeviceService.getDevices({ deviceType: "LOCKER" }),
            IotDeviceService.LockerService.getBoxes()
        ]);

        this.setState({
            dataFetchAttempted: true,
            iotLockers: iotDevicesResponse.data.iotDevices,
            iotLockerBoxes: iotLockerBoxesResponse.data.lockerBoxes
        });

    }

    render() {
        return (
            <Modal
                maskClosable={false}
                width={700}
                onCancel={this.props.onCancel}
                visible={this.props.visible}

                title={this.getTitle()}
                footer={this.renderModalFooter()}>

                {this.renderModalBody()}

            </Modal>
        )
    }

    renderModalBody = () => {

        if (!this.state.dataFetchAttempted) {
            return null;
        }

        switch (this.state.step) {
            case 0:
                return this.renderLockerSelector();

            case 1:
                return this.renderSizeSelector();

            case 2:
                return this.renderBookingReviewer();

            case 3:
                return this.renderBookingSuccess();

        }

    }

    renderModalFooter = () => {

        return (
            <Row type="flex" gutter={8} justify="end">

                {this.state.step > 0 && this.state.step < 3 && (
                    <Col>
                        <Button
                            onClick={this.onClickBack}
                            disabled={this.getNextButtonIsDisabled()}>
                            {this.getPrevButtonText()}
                        </Button>
                    </Col>
                )}

                <Col>
                    <Button
                        loading={this.state.pendingConfirmationFromServer}
                        onClick={this.onClickNext}
                        type="primary"
                        disabled={this.getNextButtonIsDisabled()}>
                        {this.getNextButtonText()}
                    </Button>
                </Col>
            </Row>
        )

    }

    /* --- STEP 0 --- */
    renderLockerSelector = () => {

        const {
            iotLockers
        } = this.state;

        return (
            <div>
                {iotLockers.map(_iotLocker => {
                    return (
                        <Row
                            style={{ cursor: "pointer" }}
                            onClick={() => this.onSelectLocker(_iotLocker)}
                            type="flex"
                            gutter={8}>

                            <Col>
                                <Radio
                                    checked={this.state.selectedLockerName === _iotLocker.deviceName}>
                                </Radio>
                            </Col>

                            <Col>
                                <h4>{_iotLocker.deviceName}</h4>
                                <div>SHELL SJI</div>
                            </Col>
                        </Row>
                    );
                })}
            </div>
        )

    }

    onSelectLocker = (_iotLocker) => {

        this.setState({
            selectedLockerName: _iotLocker.deviceName
        });

    }

    /* --- STEP 1 --- */
    renderSizeSelector = () => {

        return (
            <div>
                {this.renderLockerAvailabilityBadges()}
                {this.renderDeliveryJobsSelected()}
            </div >
        )

    }

    renderLockerAvailabilityBadges = () => {

        const { iotLockerBoxes } = this.state;
        const aggregateAvailability = this.getLockerBoxAggregateAvailability(
            iotLockerBoxes
        );

        let getBackgroundColor = (availableCount) => {
            if (availableCount === 0) {
                return "black";
            }

            if (availableCount === 1) {
                return "red";
            }

            if (availableCount < 5 && availableCount > 1) {
                return "orange";
            }

            return "green";
        }

        return (
            <div>
                <h2>Locker Availability:</h2>
                <Row gutter={8} type="flex" style={{ marginBottom: 16 }}>
                    {
                        aggregateAvailability.map(boxSizeAndCount => {
                            return (
                                <Col>
                                    <div style={{
                                        padding: 8,
                                        textAlign: "center",
                                        background: getBackgroundColor(boxSizeAndCount.count),
                                        color: "white",
                                        fontWeight: "bold"
                                    }}>
                                        <div>
                                            {boxSizeAndCount.boxSize}
                                        </div>
                                        <div>
                                            {boxSizeAndCount.count}
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </div>
        )
    }

    renderDeliveryJobsSelected = () => {

        const { selectedLocationsData } = this.props;
        const { iotLockerBoxes, selectedBoxSizes } = this.state;
        const aggregateAvailability = this.getLockerBoxAggregateAvailability(
            iotLockerBoxes
        );

        return (
            <div>
                <h2>Delivery Jobs Selected:</h2>
                {
                    selectedLocationsData.map(_location => {

                        let selectedBoxSize = selectedBoxSizes.filter(boxSize => boxSize.deliveryId === _location._id)[0];

                        return (
                            <div style={{
                                padding: "16px 0px",
                                borderTop: "1px solid #eeeeee",
                            }}>
                                <Row type="flex" justify="space-between">
                                    <Col>
                                        <div>
                                            <h4>{_location.prettyDo}</h4>
                                        </div>
                                    </Col>
                                    <Col>
                                        <Select
                                            value={selectedBoxSize.boxSize}
                                            onChange={(value) => this.onSelectLockerBox(_location._id, _location.prettyDo, value)}
                                            style={{ width: 100 }}>
                                            {aggregateAvailability.map(availableLockers => {
                                                return (
                                                    <Option
                                                        disabled={availableLockers.count === 0}
                                                        value={availableLockers.boxSize}>
                                                        {availableLockers.boxSize}
                                                    </Option>
                                                )
                                            })}
                                        </Select>
                                    </Col>
                                </Row>
                                {this.renderProductTable(_location.products)}
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    renderProductTable = (_products) => {

        return (
            <div style={{ marginTop: 16 }}>
                <Row style={{ background: "#eeeeee", fontWeight: "strong" }}>
                    <Col style={{ padding: 4, textAlign: "center" }} span={1}>#</Col>
                    <Col style={{ padding: 4, textAlign: "center" }} span={3}>Qty</Col>
                    <Col style={{ padding: 4 }} span={20}>Title</Col>
                </Row>

                {_products.map((deliveryProduct, index) => {
                    return (
                        <Row>
                            <Col style={{ padding: 4, textAlign: "center" }} span={1}>{index + 1}</Col>
                            <Col style={{ padding: 4, textAlign: "center" }} span={3}>{deliveryProduct.quantity}</Col>
                            <Col style={{ padding: 4 }} span={20}>{deliveryProduct.productTitle}</Col>
                        </Row>
                    );
                })}

            </div>
        )

    }

    convertSizeToNumeric = (sizeToConvert) => {

        let sizes = {
            "_XXL": 5,
            "_XL": 4,
            "_L": 3,
            "_M": 2,
            "_S": 1,
            "_XS": 0
        }

        let sizeKey = Object.keys(sizes).filter(_sizeKey => {

            if (sizeToConvert.endsWith(_sizeKey)) {
                return true;
            }

            return false;

        });

        let numericSize = 0;

        if (sizeKey.length > 0) {
            numericSize = sizes[sizeKey[0]]
        }

        return numericSize;

    }

    getLockerBoxAggregateAvailability = (_iotLockerBoxes) => {

        let countDict = {};

        // aggregate available locker box by availability
        _iotLockerBoxes.map(_iotLockerBox => {

            if (!countDict[_iotLockerBox.boxSize]) {
                countDict[_iotLockerBox.boxSize] = 0;
            }

            if (!_iotLockerBox.availableForBooking) {
                return;
            }

            if (_iotLockerBox.isControlPanel === "y") {
                return;
            }

            countDict[_iotLockerBox.boxSize]++;

        });

        // convert dict to array, sort then hydrate with data
        return Object.keys(countDict).sort((a, b) => {

            let aNumericSize = this.convertSizeToNumeric(a);
            let bNumericSize = this.convertSizeToNumeric(b);

            return aNumericSize - bNumericSize;

        }).map(boxSize => {

            // deduct count from the current selected boxes
            for (let i = 0; i < this.state.selectedBoxSizes.length; i++) {
                const selectedBox = this.state.selectedBoxSizes[i];

                if (selectedBox.boxSize !== boxSize) {
                    continue;
                }

                countDict[boxSize]--;
            }

            return {
                boxSize,
                count: countDict[boxSize]
            };
        })

    }

    onSelectLockerBox = (deliveryId, doNumber, lockerBoxSize) => {

        let selectedBoxSizes = this.state.selectedBoxSizes.map(selectedBoxSize => {

            if (selectedBoxSize.deliveryId !== deliveryId) {
                return selectedBoxSize;
            }

            return {
                deliveryId,
                doNumber, 
                boxSize: lockerBoxSize
            };

        });

        this.setState({
            selectedBoxSizes
        })

    }


    /* --- STEP 2 --- */
    renderBookingReviewer = () => {
        return (
            <Row type="flex" justify="center">
                <Col style={{ padding: 64 }}>
                    <h2>Confirm Booking?</h2>
                </Col>
            </Row>
        )
    }

    /* --- STEP 3 --- */
    renderBookingSuccess = () => {
        return (
            <Row type="flex" justify="center">
                <Col style={{ padding: 64 }}>
                    <h2>Booking Success!</h2>
                    <p>You may print the Delivery Order (DO) to view the assigned locker box & name.</p>
                </Col>
            </Row>
        )
    }


    /* --- GENERAL --- */
    getTitle = () => {

        switch (this.state.step) {
            case 0:
                return "Select a locker";
            case 1:
                return "Confirm Sizes";
            case 2:
                return "Review Booking";
            case 3:
                return "END";
        }

    }

    getPrevButtonText = () => {

        switch (this.state.step) {

            case 0:
                return "Cancel";

            case 1:
                return "Back";

            case 2:
                return "Back";
            
        }

    }

    getNextButtonText = () => {
        switch (this.state.step) {

            case 0:
                return "Next";

            case 1:
                return "Next";

            case 2:
                return "Confirm";

            case 3:
                return "OK";

        }
    }

    getNextButtonIsDisabled = () => {
        switch (this.state.step) {

            // if user has not selected any locker
            case 0:
                return this.state.selectedLockerName === "";

            // if any jobs has not selected size
            case 1:
                return this.state.selectedBoxSizes.filter(selectedSize => selectedSize.boxSize === "").length > 0;

            case 2:
                return 0;

            case 3:
                return 0;
        }
    }

    onClickBack = () => {

        switch (this.state.step) {

            case 1:
                this.setState({
                    step: 0
                });
                break;

            case 2:
                this.setState({
                    step: 1
                });
                break;

        }

    }

    onClickNext = () => {

        if (this.getNextButtonIsDisabled()) {
            return;
        }

        switch (this.state.step) {

            case 0:
                this.setState({
                    step: 1
                });
                break;

            case 1:
                this.setState({
                    step: 2
                });
                break;

            case 2:
                this.doLockerBoxBooking();
                break;

            case 3:
                this.props.onCancel();
                break;
        }

    }

    doLockerBoxBooking = async () => {

        // if still pending confirmation
        if (this.state.pendingConfirmationFromServer) {
            return;
        }

        let loadingMsg = message.loading("Booking locker boxes...", 0);
        const lockerBoxBookingInstructions = this.state.selectedBoxSizes.map(selectedBoxSize => {
            return {
                deviceName: this.state.selectedLockerName,
                boxSize: selectedBoxSize.boxSize,
                deliveryId: selectedBoxSize.deliveryId,
                doNumber: selectedBoxSize.doNumber
            }
        });

        this.setState({
            pendingConfirmationFromServer: true
        }, async () => {

            let response = await IotDeviceService
                .LockerService
                .postBoxBooking(lockerBoxBookingInstructions);

            console.log(response.data);
            if (response.data.success) {

                loadingMsg();

                message.success("Booking Success");

                this.setState({
                    pendingConfirmationFromServer: false,
                    step: 3
                });

            }

        });

    }


}

export default BookLockerBoxModal;


// WEBPACK FOOTER //
// ./src/components/delivery-page/book-locker-box-modal.js